import React, { useEffect, useState } from 'react';
import styles from './styles.module.scss';
import Flag from './components/Flag/index';
import { flagResolver } from '~utils/flagResolver';

export interface CountryRef {
    name: string;
    flag?: string | null;
}

interface Props {
    countries: Array<string | CountryRef>;
}

function toCountryRef(c: string | CountryRef): CountryRef {
    return typeof c === 'string' ? { name: c } : c;
}

function resolveFlag(c: CountryRef): string | null {
    if (c.flag) return c.flag;
    return flagResolver.resolve(c.name);
}

function Flags({ countries }: Props) {
    const [, setTick] = useState(0);
    useEffect(() => {
        const unsubscribe = flagResolver.subscribe(() => setTick(t => t + 1));
        return unsubscribe;
    }, []);

    return (
        <div className={`row middle ${styles.container}`}>
            {countries.map(raw => {
                const c = toCountryRef(raw);
                const flagIcon = resolveFlag(c);
                if (flagIcon) {
                    return <Flag src={flagIcon} label={c.name} />
                }
            })}
        </div>
    )
}

export default Flags
